<template>
  <div class="policy-page">
    <WeCircularNavbar @go-home="goHome" @go-countries="goCountries" />

    <main class="policy-page__container">
      <button class="back-button" type="button" @click="goBackToCountry">
        ← Back
      </button>

      <section class="policy-hero">
        <div class="policy-hero__content">
          <h1 class="policy-title">Policy Instruments and Incentives</h1>

          <p class="policy-intro">
            This section provides an overview of key policy tools and incentive mechanisms supporting women-led
            enterprises, the circular economy, Industry 4.0 adoption, and smart specialisation objectives across Europe.
          </p>
        </div>
      </section>

      <section class="policy-cards-section">
        <div class="policy-cards">
          <div class="policy-cards-grid">
            <article class="policy-card">
              <h2 class="policy-card__title">Funding and Access to Finance</h2>

              <p class="policy-card__text">
                Explore funding opportunities and financial instruments that enable innovation, growth and sustainable
                transformation.
              </p>

              <ul class="policy-card__list">
                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3730" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">EU Funding Programmes</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>

                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3731" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">Regional Development Funds</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>

                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3732" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">Publicly Backed Loans &amp; Guarantees</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>

                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3734" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">Partnership &amp; Pilot Project Grants</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>

                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3735" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">Testbed &amp; Pilot Project Grants</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>
              </ul>
            </article>

            <article class="policy-card">
              <h2 class="policy-card__title">Taxation, Financial and Other Incentives</h2>

              <p class="policy-card__text">
                Learn about tax measures and incentive schemes designed to stimulate green investment and circular
                competitiveness.
              </p>

              <ul class="policy-card__list">
                <li>
                  <a href="https://www.b2greenhub.eu/getFunded/3733" target="_blank" rel="noopener noreferrer">
                    <span class="policy-card__link-text">Tax Incentives &amp; Credits</span>
                    <span class="policy-card__icon">→</span>
                  </a>
                </li>
              </ul>
            </article>
          </div>
        </div>
      </section>
    </main>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'

export default {
  name: 'PolicyInstrumentsAndIncentives',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  emits: ['go-home', 'go-countries'],
  methods: {
    goBackToCountry() {
      if (this.$route.query.country) {
        this.$router.push({
          path: '/we-circular',
          query: {
            country: this.$route.query.country
          }
        })
      } else {
        this.$router.push('/we-circular')
      }
    }
  }
}
</script>

<style scoped>
.policy-page {
  min-height: 100vh;
  background: #f3f3f3;
  padding: 22px 0 64px;
}

.policy-page__container {
  width: 100%;
  max-width: 80%;
  margin: 0 auto;
  padding: 0 38px;
  margin-bottom: 5vw;
  box-sizing: border-box;
  text-align: left;
}

.back-button {
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  height: 30px;
  min-width: 66px;
  padding: 0 12px;
  margin-bottom: 22px;
  border: 1px solid #003399;
  border-radius: 8px;
  background: transparent;
  color: #003399;
  line-height: 1;
  cursor: pointer;
  margin-left: 0;
  font-size: 13px;
}

.policy-hero {
  margin-bottom: 26px;
}

.policy-hero__content {
  max-width: 580px;
}

.policy-title {
  margin: 0;
  max-width: 580px;
  color: #003399;
  line-height: 1.02;
  font-weight: 600;
  letter-spacing: -0.03em;
  text-align: left;
  font-size: 54px;
  text-align: left;
}

.policy-intro {
  max-width: 320px;
  margin: 16px 0 26px;
  color: #0e6eb6;
  line-height: 1.55;
  text-align: left;
  font-size: 14px;
  text-align: left;
}

.policy-cards-section {
  width: 100%;
}

.policy-cards {
  position: relative;
  width: 100%;
  min-height: 405px;
  border-radius: 14px;
  overflow: hidden;
  background: #004f4f;
  background-image: url('../../assets/img/we-circular/9-16@4x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 22px 28px 26px;
  box-sizing: border-box;
}

.policy-cards::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 79, 79, 0.42);
  pointer-events: none;
}

.policy-cards-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 44px;
}

.policy-card {
  min-width: 0;
}

.policy-card__title {
  margin: 0 0 18px;
  color: #ffffff;
  font-weight: 600;
  line-height: 1.25;
  text-align: left;
  font-size: 28px;
  max-width: 320px;
}

.policy-card__text {
  margin: 0 0 20px;
  max-width: 360px;
  color: #ffffff;
  line-height: 1.55;
  text-align: left;
  font-size: 14px;
}

.policy-card__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.policy-card__list li {
  width: 100%;
}

.policy-card__list a {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  text-decoration: none;
  color: #ffffff;
}

.policy-card__list a:hover .policy-card__link-text {
  text-decoration: underline;
}

.policy-card__link-text {
  display: inline-block;
  flex: 1;
  color: #ffffff;
  line-height: 1.45;
  text-align: left;
  word-break: break-word;
  font-size: 13px;
}

.policy-card__icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #005ed9;
  color: #ffffff;
  line-height: 1;
  margin-top: 2px;
  font-size: 11px;
}

@media (max-width: 1100px) {
  .policy-page__container {
    max-width: 92%;
    padding: 0 20px;
  }

  .policy-cards-grid {
    gap: 28px;
  }
}

@media (max-width: 900px) {
  .policy-title {
    font-size: 28px;
  }

  .policy-card__title {
    font-size: 20px;
  }

  .policy-cards-grid {
    grid-template-columns: 1fr;
  }

  .policy-cards {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .policy-page {
    padding-bottom: 48px;
  }

  .policy-title {
    font-size: 22px;
  }

  .policy-intro {
    max-width: 100%;
    font-size: 12px;
  }

  .policy-card__title {
    font-size: 18px;
  }

  .policy-card__text,
  .policy-card__link-text {
    font-size: 12px;
  }

  .policy-card__icon {
    width: 16px;
    height: 16px;
    font-size: 10px;
  }
}
</style>
